export var PHONE_REGEX = /^(\+?[0-9][\s.-/]?[0-9]{0,3}|\+?[0-9]{2,4}[\s.-/]?[0-9]?)?(\s.-\/)?([0-9]{2,4}[\s.-/]?)?([\s.-/]?[0-9]+)+$/im;
export var GLOBAL_PHONE_REGEX = /[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{1,6}/g;
export var EMAIL_REGEX = /[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)/;
export var DATE_REGEX = /^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}/g;
export var EXCLUDED_REGEX = ["S ID: ", "RIF: R", "RIF. "];
export var ROOMS_REGEX = /[0-9]{1,2}/;
export var SQM_REGEX = /[0-9]{1,5}/;
export var PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&+=!_*?]).{8,32}$/;
export var EMAIL_REGEX_INTO_TEXT = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;
export var COMPETITOR_REGEX = /(https:\/\/)?(www.)?(immobiliare|idealista).it([/a-zA-Z0-9-]+)/mi;